import classNames from 'classnames';
import { Spin } from 'lego-on-react';
import * as React from 'react';
import { useCallback } from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { mapTagValueToString } from '../../../service/TagCloudTargetingHelper/TagCloudTargetingHelper';
import { ExtendedTagValue, TagState } from '../../../typings/tagCloudTargeting';
import { Shape2, Shape2Icon } from '../../Shape2/Shape2';

import './Tag.css';

const BLOCK = 'tag';

export interface TagProps {
    cls?: string;
    tagValue: ExtendedTagValue;
    index: number;
    prefix?: string;
    onDelete: (index: number) => void;
    onClick?: (index: number) => void;
}

export const Tag: React.FunctionComponent<TagProps> = React.memo(
    ({ cls, tagValue, onClick, onDelete, prefix, index }) => {
        const { renderValue, value, tagState } = tagValue;
        const bemMods = { state: tagState };

        const onTagDelete = useCallback(
            (evt: React.MouseEvent) => {
                evt.stopPropagation();
                onDelete(index);
            },
            [index]
        );

        const onTagClick = useCallback(
            (evt: React.MouseEvent) => {
                evt.stopPropagation();
                if (onClick) {
                    onClick(index);
                }
            },
            [index]
        );

        if (tagState === TagState.LOADING) {
            return <Spin progress={true} size={'xs'} />;
        }

        return (
            <span className={classNames(Bem.cls(BLOCK, undefined, bemMods), cls)} onClick={onTagClick}>
                {prefix}
                {renderValue ? mapTagValueToString(renderValue) : mapTagValueToString(value)}

                <Shape2
                    width={9}
                    height={9}
                    icon={Shape2Icon.closeTag}
                    cls={Bem.cls(BLOCK, 'icon')}
                    onClick={onTagDelete}
                />
            </span>
        );
    }
);
